var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-notice-bar",class:_vm.type},[(_vm.type==='default')?_c('div',{staticClass:"icon-alert"}):_vm._e(),(_vm.type==='warning')?_c('div',{staticClass:"icon-warning"}):_vm._e(),(_vm.type==='error')?_c('div',{staticClass:"icon-error"}):_vm._e(),_c('div',{staticClass:"ui-notice-bar-content ui-nowrap"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee445af","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/notice-bar/index.vue
// module id = 578
// module chunks = 0 1 2 3